import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const styleObject = css`
  border-bottom: 1px solid ${theme.colors.neutral30};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing(2, 0)};

  &:first-of-type {
    border-top: 1px solid ${theme.colors.neutral30};
  }
`;

const itemText = css`
  margin: ${theme.spacing(0, 2, 0, 0)};
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ListFieldItemStyles = {
  listFieldItem: styleObject,
  itemText,
};
